/*
 *  Document   : client-edit.js
 *  Author     : Exapoint
 *
 */

// Import required modules

import ExaHelpers from "../exa_helpers";

export default class Register {

    /*
    * Auto called when creating a new instance
    *
    */
    constructor() {
        window["Register"] = this;
        this.init();
    }

    init() {
        ExaHelpers.validation();
        this.initValidation();

        let $registerInfoModal = $('#register-info-modal');

        $registerInfoModal.on('show.bs.modal', function (e) {
            let $modal = $(e.target);
            let $target = $(e.relatedTarget).first();
            let iframeId = '_' + Math.random().toString(36).substr(2, 9);

            $modal.find('.modal-content').html(`<iframe src="${$target.data('remote')}?minimal_layout=true" onload="adaptIframe()" id="${iframeId}"></iframe>`);
            let $iframe = $('#' + iframeId);
            $iframe.hide();

            window.adaptIframe = function () {
                if(window.frames.length){
                    window.frames[window.frames.length-1].onerror = window.onerror;
                }
//html { overflow-x: hidden; }
                $iframe.contents().find("head")
                    .append($(`
                    <style type='text/css'>
                        #main-container { margin-bottom: 12px; }
                        #page-container.page-header-fixed #main-container {
                            padding-top: 0;
                        }
                        #sidebar, #page-header, #page-footer, .sidebar, .main-header {
                            display:none !important;
                        }
                        #page-container.sidebar-o {
                            padding-left: 0;
                        }
                        .main-container {
                            left: 0px !important;
                            top: 0px !important;
                            padding: 0 60px !important;
                            margin-left: 0px !important;
                            margin-top: 0px !important;
                            margin-bottom: 26px;
                            max-width: 99% !important;
                        }
                        .layout-container.view {
                            max-width: 100% !important
                        }
                        @media(max-width:992px) { .main-container { padding: 0 !important; } }
                     </style>`));
                $iframe.show();
                $iframe.height('67.5vh');

                // Setting it to iframe contents height is too low
                // $iframe.height($iframe.contents().height());
            };
        });
    }

    initValidation() {
        $('.js-validation').validate({
            ignore: [],
            rules: {
                'first_name': {
                    required: true,
                },
                'last_name': {
                    required: true,
                },
                'email': {
                    required: true,
                },
                'mobile_number_intl': {
                    required: true,
                    intlTelNumber: true,
                },
                'accepted_terms': {
                    required: true,
                }
            },
        });

        // Init Validation on Select2 change
        $('.js-select2:not(.skip-validation)').on('change', e => {
            $(e.currentTarget).valid();
        });
    }
}
